var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from 'styled-components';
import aup from '../../../images/inputs/aup.svg';
export var AupArrowSvgWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background: url(", ") no-repeat center;\n  width: 12px;\n  height: 7px;\n  transition: 0.2s transform;\n  transform: ", ";\n"], ["\n  background: url(", ") no-repeat center;\n  width: 12px;\n  height: 7px;\n  transition: 0.2s transform;\n  transform: ", ";\n"])), aup, function (_a) {
    var isClosed = _a.isClosed;
    return isClosed ? 'rotate(0deg)' : 'rotate(180deg)';
});
export var AupArrowSvg = function (_a) {
    var isClosed = _a.isClosed;
    return React.createElement(AupArrowSvgWrapper, { isClosed: isClosed || true });
};
var templateObject_1;
//# sourceMappingURL=aup.js.mapvar __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from 'styled-components';
import aup from '../../../images/inputs/aup.svg';
export var AupArrowSvgWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background: url(", ") no-repeat center;\n  width: 12px;\n  height: 7px;\n  transition: 0.2s transform;\n  transform: ", ";\n"], ["\n  background: url(", ") no-repeat center;\n  width: 12px;\n  height: 7px;\n  transition: 0.2s transform;\n  transform: ", ";\n"])), aup, function (_a) {
    var isClosed = _a.isClosed;
    return isClosed ? 'rotate(0deg)' : 'rotate(180deg)';
});
export var AupArrowSvg = function (_a) {
    var isClosed = _a.isClosed;
    return React.createElement(AupArrowSvgWrapper, { isClosed: isClosed || true });
};
var templateObject_1;
//# sourceMappingURL=aup.js.map